export const BRAND_NAME = 'PlaySky11';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'playsky11.com';
export const PROVIDER_ID = 'BetFair';
